import React from "react";
import { Navigate } from "react-router-dom";
import usePermissions from "../hook/userPermission";
import NoPermissionPage from "../pages/NoPermissionPage";

// List of pages in the order they appear in the sidebar menu
const sidebarMenuPaths = [
  { path: "/roles", permission: "User Roles" },
  { path: "/employees", permission: "Managers" },
  { path: "/categories", permission: "Category" },
  { path: "/products", permission: "Products" },
  { path: "/location", permission: "Location" },
  { path: "/client-groups", permission: "Exhibitors" },
  { path: "/unwanted-enquiries", permission: "Unwanted Enquiries" },
  { path: "/exhibitors", permission: "Clients" },
  { path: "/ads", permission: "Flash News" },
  { path: "/stall-type", permission: "Stall Type" },
  { path: "/sources", permission: "Source" },
  { path: "/banners", permission: "Banner Ads" },
  { path: "/present-expo", permission: "Current Expo" },
  { path: "/past-expo", permission: "Past Expo" },
  { path: "/interest-list", permission: "Website Enquiries" },
  { path: "/visitor-booking-list", permission: "Visitor Booking List" },
  { path: "/stall-booking-list", permission: "Stall Booking List" },
  { path: "/reports/payment", permission: "Payment Report" },
  { path: "/refund-list", permission: "Refund List" },
  { path: "/reports/event-manager", permission: "Event Manager Report" },
  { path: "/user-list", permission: "User List" },
  { path: "/today-followup", permission: "Today Followup" },
  { path: "/generate-id", permission: "ID Card Generator" },
  { path: "/feedback", permission: "Feedback" },
  { path: "/careers", permission: "Careers" },
  { path: "/contact-us", permission: "Contact Us" },
  { path: "/reports", permission: "Report" },
  { path: "/user-log", permission: "User Log" },
  { path: "/profile-corrections", permission: "Support" }
];

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { hasPermission, loading } = usePermissions();

  if (loading) {
    return (
      <div 
        className="d-flex justify-content-center align-items-center" 
        style={{ 
          height: "100vh", 
          backgroundColor: "#f7e7da", // Matches layout base background
          flexDirection: "column",
          gap: "16px"
        }}
      >
        <div 
          className="spinner-border" 
          role="status" 
          style={{ 
            color: "#ed1c24", 
            width: "3rem", 
            height: "3rem",
            borderWidth: "0.25em"
          }}
        >
        </div>
        <span style={{ color: "#4a4a4a", fontWeight: "600", fontSize: "15px", letterSpacing: "0.5px" }}>
          Verifying Permissions...
        </span>
      </div>
    );
  }

  // If the user lands on the Dashboard (/) but does not have Dashboard view permission,
  // find the first menu item they have access to and redirect them there.
  if (requiredPermission === "Dashboard" && !hasPermission("Dashboard")) {
    const firstAvailable = sidebarMenuPaths.find(item => hasPermission(item.permission));
    if (firstAvailable) {
      return <Navigate to={firstAvailable.path} replace />;
    }
  }

  // If a specific permission is required, check it
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <NoPermissionPage />;
  }

  return children;
};

export default ProtectedRoute;
